"use client";

import { iNotesBlockData } from "@/@sdk/holiday-quotes-x/holiday-quotes-x-model";
import { HtmlContentWithReadMore } from "@/components/common/html-content-with-read-more";

interface NotesSectionProps extends iNotesBlockData {
  heading?: string;
}

export function NotesSection({ heading, notes }: NotesSectionProps) {
  if (!notes) {
    return (
      <section className="bg-white rounded-lg shadow-md p-4 sm:p-6 space-y-4 sm:space-y-8">
        <div className="text-center text-gray-500">
          <p className="text-sm sm:text-base">No notes added</p>
        </div>
      </section>
    );
  }

  return (
    <section className="bg-white rounded-lg shadow-md p-4 sm:p-6 space-y-4 sm:space-y-8">
      {heading && (
        <h2 className="text-xl sm:text-2xl font-semibold mb-4 sm:mb-6">{heading}</h2>
      )}
      
      {/* Mobile: Use HtmlContentWithReadMore for compact display */}
      <div className="sm:hidden">
        <HtmlContentWithReadMore
          html={notes}
          maxWords={50}
          className="prose max-w-none text-sm"
        />
      </div>
      
      {/* Desktop: Regular HTML display */}
      <div className="hidden sm:block prose max-w-none">
        <div dangerouslySetInnerHTML={{ __html: notes }} />
      </div>
    </section>
  );
} 